import { getAuth } from 'firebase/auth';
import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import Loading from './Loading';
import { getDatabase, ref, get } from 'firebase/database';
import { checkUserAllowed } from '../Tools/tools';
import GlobalContext from './GlobalContext';

function CheckForLogin({ page, app, requiredRole }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const { setGlobalData } = useContext(GlobalContext);
  const auth = getAuth(app);
  const path = useLocation();

  function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
  }

  useEffect(() => {
    setIsAuthenticated(getCookie('firebaseAuth'));

    const timer = setTimeout(async () => {
      if (auth !== null && auth.currentUser !== null) {
        const userPerm = await checkUserAllowed(auth.currentUser.uid);

        if (!userPerm) {
          await auth.signOut();
          setIsAuthenticated(false);
          return;
        }

        const db = getDatabase();
        const userPath = `roles/${auth.currentUser.uid}`;
        const roleRef = ref(db, userPath);
        const companyRef = ref(db, `${userPath}/company`);

        let role = '';
        let company = '';

        try {
          const roleSnap = await get(roleRef);
          if (roleSnap.exists()) {
            const roleData = roleSnap.val();

            const roles = Object.entries(roleData)
              .filter(([key]) => key !== 'company')
              .map(([, value]) => value);

            role = roles[0] ?? '';
          }

          const companySnap = await get(companyRef);
          if (companySnap.exists()) {
            company = companySnap.val();
          }
        } catch (error) {
          console.error('Erro ao buscar dados do usuário:', error);
        }

        if (requiredRole && !requiredRole.includes(role)) {
          await auth.signOut();
          setIsAuthenticated(false);
          return;
        }

        setGlobalData(prevState => ({
          ...prevState,
          uid: auth.currentUser.uid,
          role,
          company,
        }));

        const username = auth.currentUser.displayName ?? auth.currentUser.email ?? `Visitante ${company}`;
        localStorage.setItem("navBarUsername", username);

        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [auth, app, requiredRole, setGlobalData]);

  if (isAuthenticated === null) {
    return <Loading />;
  }

  if (isAuthenticated) {
    document.cookie = `firebaseAuth=true; max-age=7200; path=/`;
    return page;
  } else {
    document.cookie = "firebaseAuth=; max-age=0; path=/";
    window.localStorage.setItem('redirectPath', path.pathname);
    localStorage.removeItem("navBarUsername");
    return <Navigate to='/login' />;
  }
}

export default CheckForLogin;
